import type { Didomi } from '$lib/services/tracking/googleAnalytics/type';
import { browser } from '$app/environment';

// SDK API: https://developers.didomi.io/cmp/web-sdk/reference/api
// Be careful to not use SDK Deprecated API (https://developers.didomi.io/cmp/web-sdk/reference/api/deprecated)

export function handleVendorConsent(vendorAppId: string, enableVendor: () => void) {
	if (!browser) {
		return;
	}
	window.didomiOnReady?.push((didomi: Didomi) => {
		const userStatus = didomi.getCurrentUserStatus();

		const userVendor = userStatus.vendors[vendorAppId];

		if (userVendor.enabled) {
			enableVendor();
		} else if (userStatus.regulation === 'gdpr') {
			didomi.addVendorStatusListener(vendorAppId, (vendor) => {
				if (vendor.enabled) {
					enableVendor();
				}
			});
		} else {
			// Consent is not required, enable your vendor immediately
			enableVendor();
		}
	});
}

export function createCheckConsentForVendor(vendorId: string) {
	return () => {
		if (browser && typeof window.Didomi?.getUserConsentStatusForVendor === 'function') {
			return window.Didomi.getUserConsentStatusForVendor(vendorId);
		}
		return false;
	};
}

export function showElementAfterDidomiModal(callback: () => void) {
	if (browser) {
		window.didomiOnReady = window.didomiOnReady || [];
		window.didomiOnReady.push(() => {
			window.Didomi?.once('notice.hidden', callback);
		});
	}
}
